import { getList } from 'redux/modules/staff/selectors';

export default getList;
